import { render, staticRenderFns } from "./DeclareEnterpriseView.vue?vue&type=template&id=1ec59525&"
import script from "./DeclareEnterpriseView.vue?vue&type=script&lang=js&"
export * from "./DeclareEnterpriseView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports